var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircularPatternLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    fill: "none",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 47.5,
    stroke: "url(#a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 79.5,
    stroke: "url(#b)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 111.5,
    stroke: "url(#c)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 143.5,
    stroke: "url(#d)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 143.5,
    stroke: "url(#e)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 175.5,
    stroke: "url(#f)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 207.5,
    stroke: "url(#g)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 240,
    r: 240,
    stroke: "url(#h)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 288,
    x2: 173.125,
    y1: 192,
    y2: 228.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 320,
    x2: 128.542,
    y1: 160,
    y2: 220.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 352,
    x2: 83.959,
    y1: 128,
    y2: 212.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 384,
    x2: 39.376,
    y1: 96,
    y2: 205.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 384,
    x2: 39.376,
    y1: 96,
    y2: 205.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 416,
    x2: -5.207,
    y1: 64,
    y2: 197.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 448,
    x2: -49.79,
    y1: 32,
    y2: 189.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 480,
    x2: -94.373,
    y1: 0,
    y2: 181.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC52FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularPatternLg);
export default __webpack_public_path__ + "static/media/circular-pattern-lg.23449b62a450a22efbd08a720ee31346.svg";
export { ForwardRef as ReactComponent };